export default __webpack_public_path__ + "static/media/twitter.5b227490.gif";